export default __webpack_public_path__ + "static/media/rheinerft1_dark.45c2ba4c.png";